import { useState } from 'react';
import { ButtonField, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ButtonGroupItem, InputField } from '@wk/components-react16';
import { API_URL } from '../../../config/constants';
import HttpService from "../../../config/http.service";
import { Toast } from '../../../services';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

const AddProject = ({ data }: any) => {
    const { isOpenAddEdit, setIsOpenAddEdit, selectedItem, setIsLoad } = data;
    const { authProject } = useSelector((state: RootState) => state.auth);
    const defaultFormObj = {
        id: selectedItem.id ? selectedItem.id : null,
        question: selectedItem.question ? selectedItem.question : '',
        description: selectedItem.description ? selectedItem.description : '',
        example: selectedItem.example ? selectedItem.example : '',
        projectId: selectedItem.projectId ? selectedItem.projectId : authProject.id,
    };
    const [formField, setFormField] = useState(defaultFormObj);

    const handleUserRequest = (origin: string) => {
        if (origin === 'esc' || origin === 'header' || origin === 'footer') {
            setIsOpenAddEdit(false);
        }
    }

    const handleInputChange = (event: any) => {
        const { name, value } = event.target;
        setFormField({
            ...formField,
            [name]: value,
        });
    };

    const isValid = () => {
        if (!formField.question || !formField.question.trim()) {
            Toast('Please enter question', "error");
            return false;
        }
        if (!formField.description || !formField.description.trim()) {
            Toast('Please enter description', "error");
            return false;
        }
        if (!formField.example || !formField.example.trim()) {
            Toast('Please enter example', "error");
            return false;
        }
        return true;
    };

    const handleAddQuestion = async () => {
        if (!isValid()) return;
        HttpService.postRequest(API_URL.ADD_GUIDED_PROMPT_QUESTION, formField).then(
            (res: any) => {
                Toast(selectedItem?.id ? "Guided question updated successfully." : "Guided question added successfully.", "success");
                setIsLoad(true);
                setIsOpenAddEdit(false);
            },
            (err: any) => {
                Toast(err.message, "error")
            },
        )
    }

    return (
        <div>
            <Modal
                isOpen={isOpenAddEdit}
                srLabelledBy={'modal-id-guidedquestion'}
                srDescribedBy={'modal-id-guidedquestion'}
                onUserRequest={handleUserRequest}>
                <ModalHeader
                    titleId={'modal-id-guidedquestion'}
                    isFullscreenButtonVisible={false}
                    onUserRequest={() => handleUserRequest('header')}>
                    {selectedItem?.id ? 'Edit Guided Question' : 'Add Guided Question'}
                </ModalHeader>
                <ModalBody descriptionId="modal-id-guidedquestion">
                    <div className='wk-grid-page-container p-0'>
                        <div className='wk-row mb-10'>
                            <div className="wk-col-12">
                                <InputField label="Question" labelFor="question-name-1" size="small" indicator="required">
                                    <input
                                        type="text" id="question-name-1" name="question"
                                        placeholder="Question"
                                        onChange={(event: any) => handleInputChange(event)}
                                        value={formField.question} autoComplete="off"
                                    />
                                </InputField>
                                <InputField label="Description" labelFor="description-text-1" size="small" indicator="required">
                                    <input
                                        type="text" id="description-text-1" name="description"
                                        placeholder="Question Description"
                                        onChange={(event: any) => handleInputChange(event)}
                                        value={formField.description} autoComplete="off"
                                    />
                                </InputField>
                                <InputField label="Example" labelFor="question-example-1" size="small" indicator="required">
                                    <input
                                        type="text" id="question-example-1" name="example"
                                        placeholder="Example"
                                        onChange={(event: any) => handleInputChange(event)}
                                        value={formField.example} autoComplete="off"
                                    />
                                </InputField>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup mode="static">
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField size={'small'} mode={'ghost'}>
                                <button type="button" className="mr-10"
                                    onClick={() => handleUserRequest('footer')}>
                                    Cancel
                                </button>
                            </ButtonField>
                            <ButtonField size={'small'}>
                                <button
                                    type="button"
                                    id="save"
                                    onClick={handleAddQuestion}>
                                    Save
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default AddProject;